/* Pasolino — scripts propios (prefijo pl-). Vanilla JS, sin librerías. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var items = document.querySelectorAll('.pl-reveal');
    if (!items.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('pl-visible'); });
      return;
    }

    function revelar(el) {
      if (el.classList.contains('pl-visible')) return;
      var parent = el.parentElement;
      var siblings = Array.prototype.filter.call(parent.children, function (c) {
        return c.classList && c.classList.contains('pl-reveal');
      });
      var idx = siblings.indexOf(el);
      var delay = Math.min(idx, 6) * 0.09;
      el.style.setProperty('--pl-delay', delay + 's');
      el.classList.add('pl-visible');
    }

    // rootMargin positivo: el elemento se marca visible ANTES de entrar del
    // todo en pantalla, para que un scroll rápido (flick en móvil) o un
    // scrollTo instantáneo no se "salte" el aviso de intersección.
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          revelar(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0, rootMargin: '0px 0px 240px 0px' }
    );

    items.forEach(function (el) { observer.observe(el); });

    // Red de seguridad: por si algún elemento queda ya visible en pantalla
    // sin que el observer llegara a avisar (casos límite de saltos de scroll).
    function redDeSeguridad() {
      items.forEach(function (el) {
        if (el.classList.contains('pl-visible')) return;
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) {
          revelar(el);
          observer.unobserve(el);
        }
      });
    }
    window.addEventListener('scroll', redDeSeguridad, { passive: true });
    window.addEventListener('load', redDeSeguridad);
  }

  function initParallax() {
    if (reduceMotion) return;
    var layers = document.querySelectorAll('.pl-parallax');
    if (!layers.length) return;

    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      layers.forEach(function (layer) {
        var rect = layer.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        var progress = (rect.top) / vh; // -1..1 aprox
        var strength = parseFloat(layer.getAttribute('data-pl-strength') || '18');
        var y = progress * strength;
        layer.style.transform = 'translate3d(0,' + y.toFixed(2) + 'px,0) scale(1.08)';
      });
      ticking = false;
    }
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function initHeroLines() {
    var lines = document.querySelectorAll('.pl-hero__title .pl-line span');
    if (!lines.length) return;
    lines.forEach(function (span, i) {
      if (reduceMotion) {
        span.style.opacity = '1';
        span.style.transform = 'none';
        return;
      }
      span.style.opacity = '0';
      span.style.transform = 'translateY(110%)';
      span.style.transition = 'opacity 0.9s cubic-bezier(0.22,1,0.36,1), transform 0.9s cubic-bezier(0.22,1,0.36,1)';
      span.style.transitionDelay = 0.15 + i * 0.09 + 's';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          span.style.opacity = '1';
          span.style.transform = 'translateY(0)';
        });
      });
    });
  }

  function initGaleriaProducto() {
    var minis = document.querySelectorAll('[data-pl-galeria-minis] .pl-producto__mini');
    var img = document.getElementById('pl-galeria-img');
    if (!minis.length || !img) return;
    minis.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var full = btn.getAttribute('data-pl-full');
        var alt = btn.getAttribute('data-pl-alt');
        if (!full) return;
        img.style.opacity = '0';
        window.setTimeout(function () {
          img.src = full;
          img.alt = alt || '';
          img.style.opacity = '1';
        }, 160);
        minis.forEach(function (b) { b.classList.remove('pl-activa'); });
        btn.classList.add('pl-activa');
      });
    });
  }

  function initVariantes() {
    var form = document.querySelector('.pl-producto__form');
    if (!form) return;
    var dataEl = form.querySelector('[data-pl-variantes]');
    var opciones = form.querySelectorAll('.pl-opcion');
    if (!dataEl || !opciones.length) return;

    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var idInput = form.querySelector('[data-pl-variant-id]');
    var boton = form.querySelector('[data-pl-boton-comprar]');
    var botonTexto = form.querySelector('[data-pl-boton-texto]');

    function seleccionActual() {
      var seleccion = [];
      opciones.forEach(function (op) {
        var activo = op.querySelector('.pl-pill.pl-activa');
        seleccion.push(activo ? activo.getAttribute('data-pl-valor') : null);
      });
      return seleccion;
    }

    function encontrarVariante() {
      var seleccion = seleccionActual();
      return variantes.find(function (v) {
        var opts = [v.option1, v.option2, v.option3].slice(0, seleccion.length);
        return opts.every(function (val, i) { return val === seleccion[i]; });
      });
    }

    function actualizar() {
      var variante = encontrarVariante();
      if (!variante) return;
      idInput.value = variante.id;
      if (variante.available) {
        boton.removeAttribute('disabled');
        if (botonTexto) botonTexto.textContent = boton.getAttribute('data-pl-texto-disponible') || botonTexto.textContent;
      } else {
        boton.setAttribute('disabled', 'disabled');
      }
    }

    opciones.forEach(function (op) {
      op.querySelectorAll('.pl-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          op.querySelectorAll('.pl-pill').forEach(function (p) { p.classList.remove('pl-activa'); });
          pill.classList.add('pl-activa');
          actualizar();
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initParallax();
    initHeroLines();
    initGaleriaProducto();
    initVariantes();
  });
})();
